import { FC } from "react";
import { CircleX, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import StatusScreen from "./status-screen";

interface Props {
  contractId: number | string;
  companyName: string;
  companyEmail: string;
}

const RefusedScreen: FC<Props> = ({ contractId, companyName, companyEmail }) => {
  const { t } = useTranslation(["contract-updates"]);
  return (
    <StatusScreen
      icon={<CircleX className="size-10 text-rose-600" />}
      iconBg="bg-rose-100"
      title={t("contract-updates:refused-title", "Changes refused")}
      description={t(
        "contract-updates:refused-description",
        "We've let {{company}} know that you refused the proposed update for contract #{{contractId}}. They'll be in touch shortly.",
        { company: companyName, contractId },
      )}
      footer={
        companyEmail ? (
          <motion.a
            href={`mailto:${companyEmail}`}
            className="inline-flex items-center gap-2 text-sm text-primary underline-offset-4 hover:underline"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.5 }}
          >
            <Mail className="size-4" />
            {companyEmail}
          </motion.a>
        ) : undefined
      }
    />
  );
};

export default RefusedScreen;
